export default class FormUtmHiddenField {
  static ckNameAttribution = '__datas_attribution';

  static sourceNameSelector = '[name="utm_source"]';
  static mediumNameSelector = '[name="utm_medium"]';
  static campaignNameSelector = '[name="utm_campaign"]';
  static gclidNameSelector = '[name="utm_gclid"]';

  static utmKeys = [
    'utm_medium',
    'mtm_medium',
    'utm_source',
    'form_utm_medium',
    'form_utm_source',
    'mtm_source',
    'utm_gclid',
    'gclid',
    'dclid',
    'fbclid',
  ];

  init() {
    for (const form of FormUtmHiddenField.getForms()) {
      form.querySelectorAll('input').forEach((input) => {
        input.addEventListener(
          'input',
          FormUtmHiddenField.onFormInputChange,
          window.supportPassive
        );
      });
    }
  }

  static getForms() {
    const formWithUtmHiddenField = [];

    (window.formWithUtmHiddenField || []).forEach((formId) => {
      const formElement = document.querySelector(`#wbq-form-${formId}`);

      if (formElement) {
        formWithUtmHiddenField.push(formElement);
      }
    });

    return formWithUtmHiddenField;
  }

  static onFormInputChange() {
    for (const form of FormUtmHiddenField.getForms()) {
      const cookieData = FormUtmHiddenField.getCookieValues(
        FormUtmHiddenField.ckNameAttribution
      );

      if (cookieData && cookieData.length) {
        let cookieDataObject = JSON.parse(cookieData);

        let sourceInput = form.querySelector(
          FormUtmHiddenField.sourceNameSelector
        );
        let mediumInput = form.querySelector(
          FormUtmHiddenField.mediumNameSelector
        );
        let campaignInput = form.querySelector(
          FormUtmHiddenField.campaignNameSelector
        );
        let gclidInput = form.querySelector(
          FormUtmHiddenField.gclidNameSelector
        );

        const urlParams = new URLSearchParams(window.location.search);
        const hasUTMParam = FormUtmHiddenField.utmKeys.some((key) =>
          urlParams.has(key)
        );

        if (sourceInput && mediumInput) {
          if (!hasUTMParam) {
            FormUtmHiddenField.updateInputValue(
              sourceInput,
              cookieDataObject?.c_datas?.source
            );
            FormUtmHiddenField.updateInputValue(
              mediumInput,
              cookieDataObject?.c_datas?.medium
            );
            FormUtmHiddenField.updateInputValue(
              campaignInput,
              cookieDataObject?.c_datas?.campaign
            );
            FormUtmHiddenField.updateInputValue(
              gclidInput,
              cookieDataObject?.c_datas?.gclid
            );
          } else {
            FormUtmHiddenField.updateInputValue(
              sourceInput,
              cookieDataObject?.f_datas?.source
            );
            FormUtmHiddenField.updateInputValue(
              mediumInput,
              cookieDataObject?.f_datas?.medium
            );
            FormUtmHiddenField.updateInputValue(
              campaignInput,
              cookieDataObject?.f_datas?.campaign
            );
            FormUtmHiddenField.updateInputValue(
              gclidInput,
              cookieDataObject?.f_datas?.gclid
            );
          }
        }

        form.querySelectorAll('input').forEach((input) => {
          input.removeEventListener(
            'input',
            FormUtmHiddenField.onFormInputChange,
            window.supportPassive
          );
        });
      }
    }
  }

  static updateInputValue(el, value) {
    if (el && value && value.length) {
      el.value = value;
    }
  }

  static getCookieValues(name) {
    let parts = `; ${document.cookie}`.split(`; ${name}=`);

    return parts.length === 2 ? parts.pop().split(';').shift() : '';
  }
}
